<div class="wrapper-md" *ngIf="data">
    <app-breadcrumbs [items]="[
                     { url: '/lesson-observations', text: 'lessonObservation_listTitle' },
                     {
                        url: '/lesson-observations/' + data.Id,
                        text: 'lessonObservation_viewTitle'
                     }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{'lessonObservation_viewTitle' | translate}}
            <app-lesson-observation-status [value]="data.Status"></app-lesson-observation-status>
        </h1>
    </header>

    <app-alert level="danger" *ngIf="data.ApprovalComment">
        <label>{{'lessonObservation_lblApprovalComment' | translate}}</label>
        <div>{{data.ApprovalComment}}</div>
    </app-alert>

    <div class="data-value">
        <label>{{'lessonObservation_lblType' | translate}}</label>
        <div>{{data.Type}}</div>
    </div>

    <div class="data-value">
        <label>{{'lessonObservation_lblDate' | translate}}</label>
        <div>{{data.Date | appDate}} ({{data.TimeFrom | appTime}} - {{data.TimeTo | appTime}})</div>
    </div>

    <div class="data-value">
        <label>{{'lessonObservation_lblLocation' | translate}}</label>
        <div>{{data.Location}}</div>
    </div>

    <div class="data-value">
        <label>{{'lessonObservation_lblSubject' | translate}}</label>
        <div>{{data.SubjectCode}} / {{data.SubjectName}}</div>
    </div>

    <div class="data-value">
        <label>{{'lessonObservation_lblProgram' | translate}}</label>
        <div>{{data.ProgramCode}} / {{data.ProgramName}} / {{data.ProgramLevel}} / {{data.ProgramType}}</div>
    </div>

    <div class="data-value">
        <label>{{'lessonObservation_lblObserver' | translate}}</label>
        <div>{{data.ObserverName}} {{data.ObserverSurname}} / {{data.ObserverStructure}} / {{getRoleDisplay(data.ObserverRoles, data.ObserverOtherRole)}}</div>
    </div>

    <div class="data-value">
        <label>{{'lessonObservation_lblTeacher' | translate}}</label>
        <div>{{data.TeacherName}} {{data.TeacherSurname}} / {{data.TeacherStructure}} / {{getRoleDisplay(data.TeacherRoles, data.TeacherOtherRole)}}</div>
    </div>

    <div class="data-value">
        <label>{{'lessonObservation_lblFormat' | translate}}</label>
        <div>{{'lessonObservation_format' + data.Format | translate}}</div>
    </div>

    <div class="data-value">
        <label>{{'lessonObservation_lblGoals' | translate}}</label>
        <div>{{goalsDisplay}}</div>
    </div>

    <div class="block">
        <header class="block-header">
            <h5>{{'lessonObservation_lblObservations' | translate}}</h5>
        </header>

        <div class="data-value">
            <label>{{'lessonObservation_lblEnvironment' | translate}}</label>
            <div>{{data.Environment}}</div>
        </div>

        <div class="data-value">
            <label>{{'lessonObservation_lblContent' | translate}}</label>
            <div>{{data.Content}}</div>
        </div>

        <div class="data-value">
            <label>{{'lessonObservation_lblProcess' | translate}}</label>
            <div>{{data.Process}}</div>
        </div>

        <div class="data-value">
            <label>{{'lessonObservation_lblPerformance' | translate}}</label>
            <div>{{data.Performance}}</div>
        </div>

        <div class="data-value">
            <label>{{'lessonObservation_lblOther' | translate}}</label>
            <div>{{data.Other}}</div>
        </div>

        <div class="data-value">
            <label>{{'lessonObservation_lblConclusion' | translate}}</label>
            <div>{{data.Conclusion}}</div>
        </div>
    </div>

    <div class="form-actions">
        <span class="form-actions-group" *ngIf="canPromote || canReview">
            <button class="btn btn-outline-primary" type="button" (click)="promote()" *ngIf="canPromote">
                <i class="fi fi-rs-text-check"></i>
                {{'lessonObservation_btnPromote' | translate}}
            </button>

            <button class="btn btn-outline-primary" type="button" (click)="review()" *ngIf="canReview">
                <i class="fi fi-rs-text-check"></i>
                {{'review' | translate}}
            </button>
        </span>

        <span class="form-actions-group">
            <button *ngIf="canEdit" class="btn btn-outline" type="button" (click)="edit()">
                <i class="fi fi-rs-pencil"></i>
                {{'edit' | translate}}
            </button>

            <button class="btn btn-outline" type="button" [routerLink]="['/lesson-observations'] | localize">
                {{'close' | translate}}
            </button>
        </span>
    </div>
</div>
